var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('text.loggedOut')))]),_c('v-btn',{on:{"click":function($event){$event.preventDefault();return _vm.closeWindow()}}},[_vm._v(_vm._s(_vm.$t('button.close')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }